import lang from './lang.json' assert { type: 'json' };

export const translator = (value: string | undefined): string => {
  if (value) {
    if ((lang as Record<string, string>)[value]) return (lang as Record<string, string>)[value];
    return value;
  } else {
    return "";
  }
};
